import { memoize } from 'lodash';
import { pipe } from 'ramda';
import {
  Grid as ActualGrid,
  withSharedHorizontalScroll,
  withEditingMask,
  withSingleClickEdit,
  withExternalFilter,
  withDefaultProps,
  withRows,
  withSelections,
  withColumns,
  withGrouping,
  withHighlightOnTaskDrawer,
} from 'components/atoms/grid';
import { withCustomLoading } from 'components/atoms/grid/plugins/with-custom-laoding';
import { withStylePreferenceProvider } from 'components/atoms/style-preference-context';
import { TaskLookupItem } from 'utils/to-store-task';
import {
  withTaskColumn,
  withProvisionalRow,
  withOnChange,
  withCreatingTasks,
  withPrivateTaskRow,
  withEditorPopups,
  withPopoverFieldEditors,
  withStatusBar,
  withDueDateColumn,
} from './plugins';

const grouper = memoize(
  (record: Record<string, unknown>) =>
    (record.taskTree as TaskLookupItem[]).map((x) => x.taskId.toString()),
  (record: Record<string, unknown>) =>
    (record.taskTree as TaskLookupItem[]).map((x) => x.taskId).join(','),
);

export const Grid = pipe(
  pipe(
    () => ActualGrid,
    withSharedHorizontalScroll,
    withEditingMask,
    withSingleClickEdit,
    withExternalFilter,
    withDefaultProps,
    withRows((record) => (record.taskId as number | string).toString()),
    withSelections,
    withGrouping(grouper),
  ),
  pipe(
    withColumns,
    withOnChange,
    withCreatingTasks,
    withDueDateColumn,
    withTaskColumn,
    withEditorPopups,
    withPopoverFieldEditors,
    withProvisionalRow,
    withPrivateTaskRow,
  ),
  withHighlightOnTaskDrawer,
  withStatusBar,
  withCustomLoading,
  withStylePreferenceProvider({ size: 'middle' }),
)();

export const DashboardGrid = pipe(
  pipe(
    () => ActualGrid,
    withSharedHorizontalScroll,
    // withSingleClickEdit,
    withDefaultProps,
    withRows((record) => (record.taskId as number | string).toString()),
  ),
  pipe(withColumns, withDueDateColumn, withTaskColumn, withPrivateTaskRow),

  withCustomLoading,
  withStylePreferenceProvider({ size: 'middle' }),
)();
